<div class="modal-header">
  <h5 class="modal-title">
    <ng-container *ngIf="!isEditing" i18n>Add</ng-container>
    <ng-container *ngIf="isEditing" i18n>Edit</ng-container> <ng-container i18n>Date Rule</ng-container>
    <small
      ><i
        matTooltip="Add conditions to automatically set a due date in relation to Arrival Date, Departure Date, or Invoice Date."
        i18n-matTooltip
        matTooltipPosition="above"
        matTooltipClass="text-center"
        class="fal info fa-question-circle"
      ></i
    ></small>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="box box-mt-has-pd clearfix">
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field class="mat-block">
          <input matInput type="number" placeholder="Days" i18n-placeholder formControlName="days" required />
          <mat-error *ngIf="form.get('operator').touched && form.get('operator').hasError('required')" i18n>
            Value is require
          </mat-error>
          <mat-error *ngIf="form.get('days').touched && form.get('days').hasError('minNumber')" i18n>
            Days need to be at least 1
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field class="mat-block">
          <mat-select formControlName="operator" placeholder="Before / After" i18n-placeholder required>
            <mat-option value="before" i18n>Before</mat-option>
            <mat-option value="after" i18n>After</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('operator').touched && form.get('operator').hasError('required')" i18n>
            Value is required
          </mat-error>
          <mat-error *ngIf="form.get('operator').touched && form.get('operator').hasError('afterInvoice')" i18n>
            Due Date should not before Invoice Date
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field class="mat-block">
          <mat-select formControlName="event" placeholder="Event" i18n-placeholder required>
            <mat-option value="arrival" i18n>Arrival Date</mat-option>
            <mat-option value="departure" i18n>Departure Date</mat-option>
            <mat-option value="invoice" i18n>Invoice Date</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('event').touched && form.get('event').hasError('required')" i18n>
            Value is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div>
      <i class="fas fa-info-circle"></i>
      <ng-container i18n
        >If after triggering this rule, due date is calculated to be before invoice date, it will set to one day after
        invoice date.</ng-container
      >
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="onClose()" type="button" [ngClass]="config.cancelBtnClass">
    <i class="fal fa-times"></i> <ng-container i18n>cancel</ng-container>
  </button>
  <button *ngIf="isEditing" (click)="onClear()" type="button" [ngClass]="config.clearBtnClass">
    <i class="fal fa-backspace"></i> <ng-container i18n>clear</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" [ngClass]="config.doneBtnClass">
    <i [ngClass]="config.doneBtnIconClass"></i> <ng-container i18n>done</ng-container>
  </button>
</div>
